import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import settings from '../icons/settings.svg';
import ContentArea from '@episerver/spa-core/Components/ContentArea';
import { buildUrlAndOpenWindow } from '../../../../utilities/StringHelpers/StringHelpers';

import Questions from '../partials/Questions/Questions';
import ListEquipments from '../partials/ListEquipments/ListEquipments';
import ProductDescription from './ProductPage';
import Linkes from '../partials/Linkes/Linkes';
import { reportDWH, goToPage } from '../EquipmentMainSlice';
import useClearStateResetFlag from '../../../../utilities/hooks/useClearStateResetFlag';


function EquipmentsPage({context, moreDetails, openInstallationGuide }) {
   const [detailsProdact, setDetailsProdact] = useState(null);
     return (
        <div>
          <ListEquipments 
            context={context} 
            moreDetails={moreDetails} 
            openInstallationGuide={openInstallationGuide} >
          </ListEquipments>
          {/* <div className='equipments-hr'></div> */}
          <Linkes context={context} pageType="equipments"></Linkes>
          {/* <div className='equipments-hr'></div> */}
          <Questions context={context}></Questions>
        </div>
    );
}
const mapStateToProps = (state) => {
  return {
    page: state.equipmentListPage.page,
    epiData: state.equipmentListPage.epiData,
    loginData: state.authentication.loginData,
  };
};

const mapDispatchToProps = {
  reportDWH,
  goToPage
};

export default connect(mapStateToProps, mapDispatchToProps)(EquipmentsPage);
